const a = {
  id: "NebraskaPick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#04003d"
  }
};
export {
  a as default
};
